import { type FC } from "react";

import { cx } from "@emotion/css";
import { Tooltip } from "@snapchat/snap-design-system";
import { InformationIcon } from "@snapchat/snap-design-system-icons";

import { SortBy } from "../../../../gql-generated/types";
import { HeaderItem, LensListHeaderSection } from "../../../../shared/components";

import { BusinessHeaderItems } from "./BusinessHeaderItems";
import {
    adsAvailabilityWidth,
    asAvailabilityWrapper,
    dateWidth,
    iconWidth,
    nameWidth,
    visibilityWidth,
} from "./HeaderWidth.styles";
import { LensStatusHeader } from "./LensStatusHeader";
import { SortableHeaderItem } from "./SortableHeaderItem";
import {
    HeaderAdsAvailabilityText,
    HeaderAdsAvailabilityTooltip,
    HeaderDateModifiedText,
    HeaderIconText,
    HeaderNameText,
} from "./messages.generated";

interface LensesListHeader {
    scrollbarWidth: number;
    showAdsAvailability?: boolean;
}

export const LensesListHeader: FC<LensesListHeader> = ({ scrollbarWidth, showAdsAvailability }) => (
    <LensListHeaderSection scrollbarWidth={scrollbarWidth}>
        <HeaderItem className={iconWidth}>
            <HeaderIconText />
        </HeaderItem>
        <SortableHeaderItem type={SortBy.SortByName} className={nameWidth}>
            <HeaderNameText />
        </SortableHeaderItem>
        <SortableHeaderItem type={SortBy.SortByDate} className={dateWidth}>
            <HeaderDateModifiedText />
        </SortableHeaderItem>
        {showAdsAvailability && (
            <HeaderItem className={cx(adsAvailabilityWidth, asAvailabilityWrapper)}>
                <HeaderAdsAvailabilityText />
                <Tooltip content={<HeaderAdsAvailabilityTooltip />}>
                    <InformationIcon />
                </Tooltip>
            </HeaderItem>
        )}
        <LensStatusHeader />
        <HeaderItem className={visibilityWidth}>Visibility</HeaderItem>
        <BusinessHeaderItems />
    </LensListHeaderSection>
);
